import moment from 'moment'

export const makeBirthday = patient => {
  return patient.birthday.length === 8
    ? moment(patient.birthday).format('YYYY.MM.DD')
    : patient.birthday.length === 6
    ? moment(patient.birthday).format('YYYY.MM')
    : patient.birthday.length === 4
    ? moment(patient.birthday).format('YYYY')
    : ''
}

export const makeBirthdayJp = patient => {
  return patient.birthday.length === 8
    ? moment(patient.birthday).format('Y年M月D日')
    : patient.birthday.length === 6
    ? moment(patient.birthday).format('Y年M月')
    : patient.birthday.length === 4
    ? moment(patient.birthday).format('Y年')
    : ''
}

export const makeBirthAge = patient => {
  const birthdayText =
    patient.birthday.length === 8
      ? moment(patient.birthday).format('YYYY.MM.DD')
      : patient.birthday.length === 6
      ? moment(patient.birthday).format('YYYY.MM')
      : patient.birthday.length === 4
      ? moment(patient.birthday).format('YYYY')
      : ''
  if (patient.deathFlg === 1) {
    if (patient.birthday && patient.deathDate) {
      return calcAge(patient) + '(死亡)' + '/' + birthdayText
    } else if (patient.deathDate) {
      return '死亡/生年月日未設定'
    }
  } else {
    return patient.birthday ? calcAge(patient) + '/' + birthdayText : ''
  }
}

export const calcAge = patient => {
  const latestDate = patient.deathDate ? moment(patient.deathDate) : moment()
  if (patient.birthday.length === 8 || patient.birthday.length === 6) {
    const ageYear = latestDate.diff(moment(patient.birthday), 'years')
    const ageMonth = latestDate.diff(moment(patient.birthday), 'month') % 12
    const y = ageYear > 0 ? ageYear : 0
    const m = ageMonth > 0 ? ageMonth : 0
    return patient.birthday.length === 8
      ? y + '歳' + m + 'ヶ月'
      : '推定' + y + '歳' + m + 'ヶ月'
  } else if (patient.birthday.length === 4) {
    const y = latestDate.year() - moment(patient.birthday).year()
    return y >= 0 ? '推定' + y + '歳' : '推定0歳'
  } else {
    return ''
  }
}

export const calcAgeAtDate = (patient, YYYYMMDD) => {
  // birthday と deathDate は患者登録時に有効性判定が行われている
  // 指定日の有効性を判定
  if (!moment(YYYYMMDD, 'YYYYMMDD', true).isValid()) {
    return ''
  }
  const atDateMoment = moment(YYYYMMDD, 'YYYYMMDD')
  // 患者の死亡日が指定日より前の場合は、空文字を返す
  if (patient.deathDate) {
    const deathDateMoment = moment(patient.deathDate, 'YYYYMMDD')
    if (deathDateMoment.isBefore(atDateMoment)) {
      return ''
    }
  }
  if (patient.birthday.length === 8) {
    const birthdayMoment = moment(patient.birthday, 'YYYYMMDD')
    // 指定日が生年月日より前の場合は、空文字を返す
    if (atDateMoment.isBefore(birthdayMoment)) {
      return ''
    }
    const y = atDateMoment.diff(birthdayMoment, 'years')
    const m = atDateMoment.diff(birthdayMoment, 'month') % 12
    return `${y}歳${m}ヶ月`
  } else if (patient.birthday.length === 6) {
    const birthdayMoment = moment(patient.birthday, 'YYYYMM')
    // 指定日が生年月より前の場合は、空文字を返す
    if (atDateMoment.isBefore(birthdayMoment, 'month')) {
      return ''
    }
    const y = atDateMoment.diff(birthdayMoment, 'years')
    const m = atDateMoment.diff(birthdayMoment, 'month') % 12
    return `推定${y}歳${m}ヶ月`
  } else if (patient.birthday.length === 4) {
    const birthdayMoment = moment(patient.birthday, 'YYYY')
    // 指定日が生年より前の場合は、空文字を返す
    if (atDateMoment.isBefore(birthdayMoment, 'year')) {
      return ''
    }
    const y = atDateMoment.year() - birthdayMoment.year()
    return `推定${y}歳`
  } else {
    return ''
  }
}

export const calcMonthAgeAtDate = (patient, YYYYMMDD) => {
  // birthday と deathDate は患者登録時に有効性判定が行われている
  // 指定日の有効性を判定
  if (!moment(YYYYMMDD, 'YYYYMMDD', true).isValid()) {
    return ''
  }
  const atDateMoment = moment(YYYYMMDD, 'YYYYMMDD')
  // 患者の死亡日が指定日より前の場合は、空文字を返す
  if (patient.deathDate) {
    const deathDateMoment = moment(patient.deathDate, 'YYYYMMDD')
    if (deathDateMoment.isBefore(atDateMoment)) {
      return ''
    }
  }
  if (patient.birthday.length === 8) {
    const birthdayMoment = moment(patient.birthday, 'YYYYMMDD')
    // 指定日が生年月日より前の場合は、空文字を返す
    if (atDateMoment.isBefore(birthdayMoment)) {
      return ''
    }
    const m = atDateMoment.diff(birthdayMoment, 'months')
    return `${m}ヶ月`
  } else if (patient.birthday.length === 6) {
    const birthdayMoment = moment(patient.birthday, 'YYYYMM')
    // 指定日が生年月より前の場合は、空文字を返す
    if (atDateMoment.isBefore(birthdayMoment, 'month')) {
      return ''
    }
    const m = atDateMoment.diff(birthdayMoment, 'months')
    return `推定${m}ヶ月`
  } else if (patient.birthday.length === 4) {
    const birthdayMoment = moment(patient.birthday, 'YYYY')
    // 指定日が生年より前の場合は、空文字を返す
    if (atDateMoment.isBefore(birthdayMoment, 'year')) {
      return ''
    }
    const m = (atDateMoment.year() - birthdayMoment.year()) * 12
    return `推定${m}ヶ月`
  } else {
    return ''
  }
}
